import React, { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import EducationCard from './EducationCard';
import { educationData } from '../../data/educationData';

import './Education.css';

function Education() {
    const { theme } = useContext(ThemeContext);

    return (
        <section
            id="education"
            className="education"
            style={{ backgroundColor: theme.secondary }}
        >
            <div className="education-shell">

                <div className="education-top">

                    <div className="education-description">
                        <span className="section-kicker">
                            EDUCATION
                        </span>

                        <h2>
                            Academic Journey &
                            <span style={{ color: theme.primary }}>
                                {" "}Continuous Learning
                            </span>
                        </h2>

                        <p>
                            My academic background established strong foundations
                            in software engineering, problem solving, system
                            architecture, and modern application development.
                            These experiences continue to influence how I build
                            scalable enterprise-grade solutions today.
                        </p>

                        <div className="education-highlights">
                            <span>Software Engineering</span>
                            <span>System Design</span>
                            <span>Algorithms</span>
                            <span>Cloud Technologies</span>
                        </div>
                    </div>

                    <div className="education-visual">
                        <div className="education-img">
                            <img
                                src={theme.eduimg}
                                alt="Education"
                            />
                        </div>

                        <div
                            className="education-stat-card"
                            style={{
                                background: theme.primary30
                            }}
                        >
                            <strong>KEY FOCUS</strong>

                            <span>
                                Building scalable software solutions using
                                modern architecture, cloud-native development,
                                and enterprise engineering practices.
                            </span>
                        </div>
                    </div>

                </div>

                <div className="education-timeline">
                    {educationData.map((edu) => (
                        <EducationCard
                            key={edu.id}
                            id={edu.id}
                            institution={edu.institution}
                            course={edu.course}
                            startYear={edu.startYear}
                            endYear={edu.endYear}
                            score={edu.score}
                        />
                    ))}
                </div>

            </div>
        </section>
    );
}

export default Education;